import { useFormik } from "formik";
import companyProcessValidationSchema from "@companyProcess/schemas/companyProcessValidationSchema";
import type { UseCompanyProcessFormProps } from "./types";
import type { CompanyProcessValues } from "@companyProcess/types/companyProcess";

const useCompanyProcessForm = ({
    companyProcess,
    isOpen,
    onClose,
    onCreateCompanyProcess,
    onUpdateCompanyProcess
}: UseCompanyProcessFormProps) => {
    
    const {
        errors, 
        values, 
        touched, 
        handleSubmit, 
        handleReset,
        handleChange, 
        setFieldValue
    } = useFormik<CompanyProcessValues>({
        initialValues: {
            empresaId: companyProcess?.empresa?.id ?? 0,
            nombre: companyProcess?.nombre ??  '',
            horaInicio: companyProcess?.horaInicio ?? '',
            horaFin: companyProcess?.horaFin ?? '',
            lunes: companyProcess?.lunes ?? false,
            martes: companyProcess?.martes ?? false,
            miercoles: companyProcess?.miercoles ?? false,
            jueves: companyProcess?.jueves ?? false,
            viernes: companyProcess?.viernes ?? false,
            sabado: companyProcess?.sabado ?? false,
            domingo: companyProcess?.domingo ?? false,
            detenido: companyProcess?.detenido ?? 0,
            activo: companyProcess?.activo ?? 0
        },
        onSubmit: async(values, {resetForm}) => {
            if(companyProcess) {
                if(await onUpdateCompanyProcess(companyProcess.id, values)){
                    resetForm()
                    if(isOpen) onClose()
                } 
                    
            } else {
                if(await onCreateCompanyProcess(values)){
                    resetForm()
                    if(isOpen) onClose()
                }
            }
        },
        enableReinitialize: true,
        validationSchema: companyProcessValidationSchema
    })

    return{
        values,
        errors,
        touched,
        handleChange,
        handleReset,
        handleSubmit,
        setFieldValue
    }
}

export default useCompanyProcessForm;